import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import Routes from './Routes';
import theme from './theme';
import './styles.scss';
import SnackBar from '../SnackBar';
import { Provider } from 'react-redux';
import store from '../../../redux/store';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import ConfirmDialog from '../ConfimDialog';

function App() {
  return (
    <Provider store={store}>
      <div className="App">   
        <ThemeProvider theme={theme}>
          <CssBaseline />   
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <SnackBar />           
            <ConfirmDialog /> 
            <Routes />
          </MuiPickersUtilsProvider>
        </ThemeProvider>    
      </div>
    </Provider>
  );
}

export default App;
